<style lang="scss">
.dashboard {
  &__logo img {
    max-width: 300px;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2">
    <div class="dashboard row">
      <div class="col-12">
        <h2 class="font-weight-bolder">Dashboard</h2>

        <section class="dashboard__logo full-width mb-2">
          <img class="d-block mx-auto" width="100%" height="auto" :src="theme === 'light' ? logo : logoWhite" alt="logo">
        </section>

        <b-row class="mt-4 px-2" cols="4">
          <b-col class="col-4">
            <icon-card cy="calls"
                       route="calls"
                       font-awesome="fas fa-phone"
                       color="info"
                       statistic-title="Calls"></icon-card>
          </b-col>
          <b-col class="col-4">
            <icon-card cy="visitors"
                       route="visitor-management"
                       font-awesome="fas fa-user"
                       color="info"
                       statistic-title="Visitors"></icon-card>
          </b-col>
          <b-col v-if="prison && prison.allow_social_visits" class="col-4">
            <icon-card route="social-visits-home"
                       font-awesome="fa fa-users"
                       color="info"
                       statistic-title="Social Visits" />
          </b-col>
          <b-col v-else class="col-4">
            <icon-card cy="kiosk"
                       route="kiosk"
                       font-awesome="fa fa-store"
                       color="info"
                       statistic-title="Kiosk"></icon-card>
          </b-col>
        </b-row>

<!--        <section class="quick-links">-->
<!--          <b-btn :to="{name: 'calls'}" class="full-width mb-1" variant="primary">Calls</b-btn>-->
<!--          <b-btn :to="{name: 'visitor-management'}" class="full-width mb-1" variant="primary">Visitors</b-btn>-->
<!--          <b-btn :to="{name: 'kiosk'}" class="full-width mb-1" variant="primary">Kiosk</b-btn>-->
<!--        </section>-->
      </div>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import IconCard from '@/components/cards/IconCard';
import HelperService from '@/services/HelperService';

export default {
  components: {
    IconCard,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logo: require('@/assets/images/logo/logo.svg'),
      logoWhite: require('@/assets/images/logo/logo-white.svg'),
      helperService: new HelperService(),
    }
  },
  computed: {
    ...mapState({
      prison: state => state.prison.prison,
      user: state => state.auth.user,
      theme: state => state.appConfig.layout.skin
    }),
  },
}
</script>
